<template>
    <dialog-lx v-bind.sync="dialogDataLeader">
        <div class="content-main">
            <div class="dialog-header">
                <div v-if="(activeLeaderList && activeLeaderList.length) || selectLeaderList.length">
                    <el-tag v-for="tag in activeLeaderList" :key="tag.playerName" closable
                        @close="closeTag(tag, 'activeLeaderList')">
                        {{ tag.playerName }}
                    </el-tag>
                    <el-tag v-for="tag in selectLeaderList" :key="tag.playerName" closable
                        @close="closeTag(tag, 'selectLeaderList')">
                        {{ tag.playerName }}
                    </el-tag>
                </div>
                <span :title="$t('planLxDetail.JYXXSZWDZ')" v-else style="display: inline-block;text-overflow: ellipsis; overflow: hidden;width: 100%; padding: 10px;box-sizing: border-box;" :style="lang == 'zh_CN' ? 'line-height:36px' : 'line-height:20px'">
                    {{ $t('planLxDetail.JYXXSZWDZ') }}
                </span>
            </div>
            <div class="dialog-content">
                <div class="content-header">
                    <span>
                        <el-input v-model="leaderInputVal" style="margin: 0 16px;"
                            @keydown.enter.native="seachStudentTableData" :placeholder="$t('planLxDetail.QRSXSXM')"
                            size="mini"></el-input>
                        <el-button type="primary" size="mini" @click="seachStudentTableData">{{ $t('planLxDetail.CX') }}
                        </el-button>
                    </span>
                    <span>
                        {{ $t('planLxDetail.YX') }} <span
                            style="font-size: 18px; color: #5397F7;">{{ activeLeaderList.length +
                                    selectLeaderList.length
                            }}</span> {{ $t('planLxDetail.R') }}
                    </span>
                </div>


                <div class="table-box">
                    <c-table ref="child" :avtiveList="avtiveList" :tableData="leaderTableData" @operation="operation"
                        :tableHeader="rightTableHeader" TableHeight="314px"></c-table>
                </div>
            </div>
        </div>
        <div slot="footer">
            <el-button size="small" @click="$emit('prev'); leaderInputVal = ''">{{ $t('planLxDetail.SYB') }}</el-button>
            <el-button type="primary" size="small" @click="saveClick">{{ $t('planLxDetail.SCTD') }}</el-button>
        </div>
    </dialog-lx>
</template>
<script>
import dialogLx from '@/components/dialog-lx'
import mins from './mins'
import cTable from '@/components/table'
import fetch from '@/api/fetch'
import {getStore} from '@/utils/common'

export default {
    name: 'leader-dialog',
    components: {
        dialogLx,
        cTable
    },
    data() {
        return {
            avtiveList: [],
            lang: getStore('lang') || 'zh_CN',
        }
    },
    mixins: [mins],
    watch: {
        'dialogDataLeader.addLxDialog'(newVal) {
            if (newVal) {
                this.getStudentList()
                this.getLeaderList()
                this.activeLeaderList = []
            }
        }
    },
    methods: {
        getStudentList() {
            fetch.list4Unuse({
                planId: this.planId
            }).then(res => {
                if (res.code == 0) {
                    this.leaderTableData = res.data.map((item, index) => ({ index: ++index, ...item }))
                    this.leaderTableDataAll = [...this.leaderTableData]
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.HQSJSB'), type: 'error' });
                }
            })
        },
        getLeaderList() {
            fetch.leaderSelect({
                planId: this.planId
            }).then(res => {
                if (res.code == 0) {
                    this.selectLeaderList = res.data ? res.data.map((val) => {
                        val.isLeader = true
                        return val
                    }) : []
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.HQSJSB'), type: 'error' });
                }
            })
        },
        seachStudentTableData() {
            let leaderTableData = [
                ...this.leaderTableDataAll.filter(item => item.playerName.indexOf(this.leaderInputVal) != -1)
            ]
            this.leaderTableData = leaderTableData.map((item, index) => ({ ...item, index: (++index) }))
        },
        closeTag(itemTag, dataKey) {
            if (itemTag.isLeader) {
                this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.DQXSYJWTDDZ'), type: 'error' });
                return
            }
            let idKey = dataKey === 'activeLeaderList' ? 'playerId' : 'id'
            this[dataKey].splice(this[dataKey].findIndex(item => item[idKey] === itemTag[idKey]), 1)
            this.$refs.child.selectTable(this[dataKey])
        },
        operation(type, rowData) {
            if (type === 'selectChange')
                this.activeLeaderList = []
            this.activeLeaderList.push(...rowData.map(item => {
                return this.activeLeaderList.findIndex(items => item.playerId === items.playerId) === -1 ? item : false
            }).filter(item => item))
        },
        saveClick() {
            let leaderIdList = [...this.activeLeaderList.map(item => (item.playerId)), ...this.selectLeaderList.map(item => (item.id))]
            if (leaderIdList.length === 0) {
                this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.ZSXZYG'), type: 'warning' });
                return false
            }
            fetch.teamCreate({
                planId: this.planId,
                leaderIdList
            }).then(res => {
                if (res.code == 0) {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: this.$t('planLxDetail.SCTDCG'), type: 'success' });
                    this.$emit('successClick')
                } else {
                    this.$notify({ title: this.$t('planLxDetail.CZ'), message: res.msg || this.$t('planLxDetail.CZSB'), type: 'error' });
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.dialog-header {
    height: 56px;
    border-bottom: 1px solid #DDE0E2;
    ;
    font-size: 14px;
    font-family: Hiragino Sans GB;
    font-weight: normal;
    text-align: center;
    color: #A0A0A6;
    /deep/ .el-tag {
        margin: 0 10px;
    }

    >div {
        width: 100%;
        height: 100%;
        white-space: nowrap;
        display: flex;
        align-items: center;
        overflow-y: auto;
    }
}

/deep/ .el-dialog__body {
    padding: 0;
}

.content-header {
    display: flex;
    justify-content: space-between;

    /deep/ .el-input {
        width: 260px;
        height: 32px;
        opacity: 1;
        border-radius: 2px;

        /deep/ .el-input__inner {
            background: #F1F2F4;
        }
    }

}

.dialog-content {
    padding: 18px 16px;
    box-sizing: border-box;
}
</style>